<script setup lang="ts">
    import { computed } from 'vue';
    import { storeToRefs } from 'pinia';
    import { useHipSpineStore } from '@/views/3d-planner/hipSpine/hipSpineStore';
    import { HIP_SPINE_ANGLE_COLOURS } from '@/views/3d-planner/hipSpine/hipSpineAnnotationDefs';
    import { formatDegrees } from '@/domain/geometry/formatMath';

    const store = useHipSpineStore();
    const { activePostureId } = storeToRefs(store);

    const rows = computed(() => {
        const vs = activePostureId.value ? store.viewState(activePostureId.value) : undefined;
        return (vs?.angles ?? []).map((angle) => ({
            id: angle.id,
            label: `${angle.displayName} (${angle.abbreviation})`,
            value: formatDegrees(angle.value, { precision: 1 }),
            colour: HIP_SPINE_ANGLE_COLOURS[angle.id],
        }));
    });
</script>

<template>
    <div class="angle-list">
        <div v-for="row in rows" :key="row.id" class="angle-row">
            <span class="angle-row-dot" :style="{ backgroundColor: row.colour }" />
            <span class="angle-row-name">{{ row.label }}</span>
            <span class="angle-row-value">{{ row.value }}</span>
        </div>
    </div>
</template>

<style scoped lang="scss">
    .angle-list {
        padding-top: 0;
        padding-bottom: 8px;
        overflow-y: auto;
    }

    .angle-row {
        display: flex;
        align-items: center;
        gap: 15px;
        padding: 15px 8px;

        &-dot {
            display: inline-block;
            width: 10px;
            height: 10px;
            border-radius: 50%;
            flex-shrink: 0;
        }

        &-name {
            font-size: 16px;
            font-weight: normal;
            color: rgba(var(--v-theme-on-surface));
            flex-grow: 1;
        }

        &-value {
            font-size: 16px;
            font-weight: normal;
            color: rgba(var(--v-theme-secondary-text));
            flex-shrink: 0;
        }
    }
</style>
